import { createContext, type RefObject } from 'react'

export const MeetingSummaryAgentContentRefContext = createContext<RefObject<HTMLDivElement> | null>(null)
